module.exports = __webpack_public_path__ + "static/media/clip.a4d1c3cd.svg";